export default __webpack_public_path__ + "static/loading_tube-ac5cc579cbad92710acc92efa873bbe9.gif";